export enum ApprovalStatus {
  DRAFT = "DRAFT",
  NOT_REQUIRED = "NOT_REQUIRED",
  REQUESTED = "REQUESTED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  LOCKED = "LOCKED",
}
